<template>
	<div>
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" label="充电站:" :label-width="100">
				<Select placeholder="站点列表" style="width: 200px;" v-model="formInline.StationId">
					<Option :value=0>全部</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">
						{{item.StationName}}</Option>
				</Select>
			</FormItem>
			<FormItem v-if="Control.select">
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
			</FormItem>
		</Form>
		<Table :columns="columns1" :data="data1" :height="tableHeight"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getChargingInfoUrl" @listData='getDeviceData'></MyPage>
		<Modal ref="ChargingCurvesModel" width="70%" v-model="modalView" :title="modal.Title">
			<div id="ChargingCurves" style="width:100%;height:300px;"> </div>
			<div slot="footer">
				<Button type="success" size="large" @click="show('closeModal')">确定</Button>
			</div>
		</Modal>
		<echartModal ref="echartModal" curvesName="realChargingCurves"></echartModal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import echartModal from '../../public/CurvesTemplate/ChargingOrderEchart.vue'
	import Qs from 'qs'
	import expandRow from './ChargingInfoExpand.vue';
	import echart from '../../../js/echarts_hot.js'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';
	export default {
		components: {
			echartModal
		},
		data() {
			return {
				getChargingInfoUrl: webapi.base_api_url + '/Operations/GetChargingInfo',
				Control: {},
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				//选择展示的充电站
				tableHeight: "650",
				modal: {
					Title: "设备信息添加",
					type: "addDevice"
				},
				modalView: false,
				BreadcrumbList: ['场站监控', '>>', '实时充电'],
				formInline: {
					StationId: 0
				},
				//table标题数据
				columns1: [{
						type: 'expand',
						width: 50,
						render: (h, params) => {
							return h(expandRow, {
								props: {
									row: params.row
								}
							})
						}
					},
					{
						title: '充电流水号',
						key: 'OrderNo',
						minWidth: 160
					},
					// {
					// 	title: '充电开始时间',
					// 	key: 'ChargeStartTime',
					// 	minWidth: 120,
					// },
					// {
					// 	title: '充电启动方式',
					// 	key: 'StartMode',
					// 	minWidth: 120,
					// 	render: (h, params) => {
					// 		return h('div', params.row.StartModeDesc)
					// 	}
					// },
					{
						title: '充电电压(V)',
						key: 'ChargeVoltage',
						minWidth: 80,
					}, {
						title: '充电电流(A)',
						key: 'ChargeCurrent',
						minWidth: 80,
					}, {
						title: '充电时长',
						key: 'ChargeDuration',
						minWidth: 90,
						render: (h, params) => {
							return h('div', params.row.ChargeDurationDesc)
						}
					}, {
						title: '充电功率(KW)',
						key: 'ChargePower',
						minWidth: 80,
					}, {
						title: '已充电量(度)',
						key: 'ChargeKwh',
						minWidth: 80,
					}, {
						title: '已充费用(元)',
						key: 'ChargeCost',
						minWidth: 80,
					}, {
						title: '当前SOC(%)',
						key: 'CurrentSoc',
						minWidth: 80,
					}, {
						title: '剩余时长',
						key: 'RemainDuration',
						minWidth: 90,
						render: (h, params) => {
							return h('div', params.row.RemainDurationDesc)
						}
					},
					// , {
					// 	title: '设备编号',
					// 	key: 'EquipmentNo',
					// }, {
					// 	title: '设备名称',
					// 	key: 'EquipmentName',
					// },
					{
						title: '枪编号',
						key: 'ConnectorNo',
						minWidth: 100,
					},
					// {
					// 	title: '枪名称',
					// 	key: 'ConnectorName'
					// },
					// {
					// 	title: '设备类型',
					// 	key: 'EquipmentType',
					// 	render: (h, params) => {
					// 		return h('div',
					// 			params.row.EquipmentTypeDesc
					// 		);
					// 	}
					// },
					// {
					// 	title: '枪类型',
					// 	key: 'ConnectorType',
					// 	render: (h, params) => {
					// 		return h('div',
					// 			params.row.ConnectorTypeDesc
					// 		);
					// 	}
					// },
					// {
					// 	title: '工作状态',
					// 	key: 'WorkStatus',
					// 	render: (h, params) => {
					// 		return h('div',
					// 			params.row.WorkStatusDesc
					// 		);
					// 	}
					// },
					// {
					// 	title: '最高告警码',
					// 	key: 'MaxAlarmCode',
					// 	render: (h, params) => {
					// 		let type = ''
					// 		let color = ''
					// 		switch (params.row.MaxAlarmCode) {
					// 			case 0:
					// 				color = "success",
					// 					type = "无告警"
					// 				break;
					// 			default:
					// 				color = "error",
					// 					type = params.row.MaxAlarmDesc
					// 				break;
					// 		}
					// 		return h('Tag', {
					// 				props: {
					// 					color: color
					// 				}
					// 			},
					// 			type
					// 		);
					// 	}
					// },
					// {
					// 	title: '连接状态',
					// 	key: 'CarCoupleStatus',
					// 	render: (h, params) => {
					// 		let type = ''
					// 		let color = ''
					// 		switch (params.row.CarCoupleStatus) {
					// 			case 0:
					// 				color = "error",
					// 					type = "未连接"
					// 				break;
					// 			default:
					// 				color = "success",
					// 					type = "已连接"
					// 				break;
					// 		}
					// 		return h('Tag', {
					// 				props: {
					// 					color: color
					// 				}
					// 			},
					// 			type
					// 		);
					// 	}
					// },
					// {
					// 	title: '额定功率',
					// 	key: 'RatedPower'
					// },
					{
						title: '站点名称',
						key: 'StationName',
						minWidth: 100,
						tooltip: true,
					}, {
						title: '操作',
						key: 'action',
						width: 200,
						align: 'center',
						render: (h, params) => {
							console.log(this.Control);
							let MyButton = [];
							if (this.hasWidgets('stopCharge')) {
								MyButton.push(
									h('Button', {
										props: {
											type: 'error',
											size: 'small'
										},
										style: {
											marginRight: '5px'
										},
										on: {
											click: () => {
												this.$Modal.confirm({
													title: '枪：' + params.row.ConnectorNo +
														' 停止充电？',
													okText: '取消',
													cancelText: '确定',
													onCancel: () => {
														this.stopCharging(params.row
															.ConnectorNo);
													}
												});
											}
										}
									}, '停止充电')
								)
							}
							if (this.hasWidgets('chargeCurves')) {
								MyButton.push(
									h('Button', {
										props: {
											type: 'primary',
											size: 'small'
										},
										style: {
											marginRight: '5px'
										},
										on: {
											click: () => {
												this.show("ChargingCurves", params.row.OrderNo)
											}
										}
									}, '充电曲线')
								)
							}
							return h('div', MyButton);
						}
					}
				],
				data1: [],

				//图标实例
				Myecharts: '',
				//图表数据
				lineEchart: {
					legend_data: ['电压曲线', '电流曲线', 'SOC曲线', '枪温度曲线'],
					seriesData: [{
							name: '电压曲线',
							type: 'line',
							stack: '分类1',
							data: [0, 0, 0, 0, 0, 0, 0]
						},
						{
							name: '电流曲线',
							type: 'line',
							stack: '分类2',
							data: [0, 0, 0, 0, 0, 0, 0]
						},
						{
							name: 'SOC曲线',
							type: 'line',
							stack: '分类3',
							data: [0, 0, 0, 0, 0, 0, 0]
						},
						{
							name: '枪温度曲线',
							type: 'line',
							stack: '分类4',
							data: [0, 0, 0, 0, 0, 0, 0]
						}
					],
					style: {
						color: "black"
					},
					TimePoins: [1, 2, 3, 4, 5, 6, 7]
				},
				timer: ''
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', _this.getTableHeight)
			//window.addEventListener('resize', echart.resizeEchart(null))
		},
		activated() {
			let col = this.$store.state.UserButton.find(item => window.location.href.indexOf(item.path) > 0);
			this.Control = col.control
			console.log(col.control);
			this.timer = setInterval(this.handleSubmit, 30000);
		},
		deactivated() {
			if (this.timer) {
				clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			}
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
			//window.removeEventListener('resize', echart.resizeEchart(null))
		},
		mounted() {
			const _this = this
			_this.handleSubmit();
		},
		beforeDestroy() {},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = _this.formInline;
				return param
			},

			//直接选属性
			...mapState({
				StationList: 'Stations'
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//操作
			show: function(type, OrderNo) {
				switch (type) {
					case "ChargingCurves":
						this.modal.type = "ChargingCurves";
						this.modal.Title = "充电曲线";
						//this.modalView = true;
						this.$refs.echartModal.show('view', OrderNo)
						//this.getChargingCurves(OrderNo);
						break;
					case "update":
						this.modal.type = "update";
						this.modal.Title = "设备信息跟新";
						this.getUpdateMessage(EquipmentNo);
						this.modalView = true;
						break;
					case "closeModal":
						echart.disposeEchart("ChargingCurves")
						this.modalView = false;
						break;
				}
			},
			stopCharging: function(ConnectorNo) {
				const _this = this
				_this.$axios.post(webapi.base_api_url + "/Archives/StopCharge", {
					ConnectorNo: ConnectorNo
				}, {
				}).then(res => {
					console.log("停止充电")
					console.log(res.data)
					if (res.data.Code == 0) {
						_this.$Message.success(ConnectorNo + '停止充电成功');
						_this.handleSubmit()
					} else {
						this.$Message.error(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
			getDeviceData: function(data) {
				console.log("分页ChargingInfo")
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
				// const _this = this;
				// let parms = {
				// 	StationId: _this.formInline.SelectStation
				// }
				// _this.$axios.post(webapi.base_api_url + "/Operations/GetChargingInfo", parms, {
				// }).then(res => {
				// 	console.log("res")
				// 	console.log(res.data)
				// 	if (res.data.Code == 0) {
				// 		_this.data1 = res.data.Data.ChargeingInfos;
				// 	}
				// })
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			},
			getChargingCurves: function(OrderNo) {
				const _this = this
				console.log(OrderNo)
				let parms = {
					OrderNo: OrderNo,
				};
				_this.$axios.post(webapi.base_api_url + "/Operations/GetChargingCurves", parms, {
				}).then(res => {
					console.log("实时充电-充电曲线res")
					console.log(res.data)
					if (res.data.Code == 0) {
						let MyTimePoins = []
						res.data.Data.Curves.ReportTime.forEach(function(time) {
							//MyTimePoins.push(time.split(" ")[0])
							MyTimePoins.push(time)
						})
						_this.lineEchart.TimePoins = MyTimePoins;
						_this.lineEchart.seriesData[0].data = res.data.Data.Curves.VoltageCurve;
						_this.lineEchart.seriesData[1].data = res.data.Data.Curves.CurrentCurve;
						_this.lineEchart.seriesData[2].data = res.data.Data.Curves.SocCurve;
						_this.lineEchart.seriesData[3].data = res.data.Data.Curves.TempConnectorCurve;
						echart.initLinechart3("ChargingCurves", _this.lineEchart)
					}
				})
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}
</style>
